import { FC } from 'react';
import Icon from '../icon';
import { Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Text from '../text';
import classNames from 'classnames';
import { IconType } from '../icon/helpers';
import {
  FlatButtonColor,
  FlatButtonSize,
  getFlatButtonIconSize,
  useFlatButtonStyles,
} from './helpers';

interface Props {
  label: string;
  icon?: IconType;
  color?: FlatButtonColor;
  onClick?: () => void;
  size?: FlatButtonSize;
  disabled?: boolean;
  dotdot?: boolean;
  inline?: boolean;
  className?: string;
}

const useStyles = createUseStyles({
  inline: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    marginLeft: 6,
  },
});

const FlatButton: FC<Props> = ({
  label,
  icon,
  onClick,
  color,
  size = 'medium',
  disabled = false,
  dotdot = true,
  inline = false,
  className = '',
}) => {
  const flatStyles = useFlatButtonStyles();
  const styles = useStyles();
  const IconEl = icon ? <Icon name={icon} size={getFlatButtonIconSize(size)} /> : null;

  const handleClick = () => {
    if (disabled) {
      return;
    }

    onClick?.();
  };

  const compClass = classNames(flatStyles.flatButton, inline && styles.inline, className, color, {
    disabled,
  });

  return (
    <Stack
      className={compClass}
      flexDirection="row"
      alignItems="center"
      role="button"
      onClick={handleClick}
      gap={1}
    >
      {IconEl}
      <Text size={size} dotdot={dotdot}>
        {label}
      </Text>
    </Stack>
  );
};

export default FlatButton;
